import isDev from 'util/isDev';
import { logErrorToGcp, logWarningToGcp, logInfoToGcp } from 'util/gcpLogging';

export function logError(error: Error, message?: string, additionalData?: Record<string, unknown>) {
  if (isDev()) {
    console.error(error, message, additionalData);
  }

  // Log to GCP
  logErrorToGcp(error, message, additionalData);
}

export function logWarning(message: string, additionalData?: Record<string, unknown>) {
  if (isDev()) {
    console.warn(message, additionalData);
  }

  // Log to GCP
  logWarningToGcp(message, additionalData);
}

export function logInfo(message: string, additionalData?: Record<string, unknown>) {
  if (isDev()) {
    console.log(message, additionalData);
  }

  // Log to GCP
  logInfoToGcp(message, additionalData);
}
